module.exports = __webpack_public_path__ + "img/hero-title-1248x832.e63816ac.jpg";